import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { IllustrationVerifiedIdSvg } from "./IllustrationVerifiedIdSvg.mjs";
const IllustrationVerifiedId = () => /* @__PURE__ */ jsx(Box, { component: IllustrationVerifiedIdSvg });
export {
  IllustrationVerifiedId
};
